exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-content[data-v-45ca7c77] {\n  font-size: .9rem;\n  border-left: 1px solid #ddd;\n  margin-left: -1px;\n  width: 100%;\n}\n", ""]);

// exports
